/* Ben's onboarding tracker (2026-11-02): his steps, in his order, one tick each. */

/*
 * The steps and each step's default lines live in creators_onboarding_step and
 * creators_onboarding_default (0007), edited from the tracker's "Edit defaults" (Jay, 2026-11-04).
 * The steps are the table's columns for every creator; the default lines are what a creator
 * starts with when they join, and each creator's copy is theirs to change after that.
 */

export type TrackerStep = string;

export type StepDef = { id: TrackerStep; label: string; icon: string | null };

export type DefaultLine = { id: string; label: string };

export type TrackerDefaults = { steps: Array<StepDef & { lines: DefaultLine[] }> };

/** What "Edit defaults" saves: every step in order with its lines in order. Ids the server doesn't know are new. */
export type DefaultsInput = { steps: Array<{ id: string; label: string; lines: DefaultLine[] }> };

export type TrackerTick = { at: string; by: string | null };

export type TrackerSubitem = { id: string; step: TrackerStep; label: string; done: TrackerTick | null };

export type TrackerCreator = {
  creator: string;
  addedAt: string;
  ticks: Partial<Record<TrackerStep, TrackerTick>>;
  plan: string;
  notes: string;
  updatedAt: string;
  updatedBy: string | null;
  subitems: TrackerSubitem[];
  /** Every account the creator has, any platform: their Socials in Creators. */
  accounts: TrackerAccount[];
};

export type TrackerAccount = {
  id: string | null;
  platform: string;
  url: string;
  handle: string | null;
  followers: number | null;
  /** Instagram only: Main Accounts reads it. */
  inMainAccounts: boolean;
};

export type Tracker = { steps: StepDef[]; creators: TrackerCreator[]; available: string[] };

/** Every step ticked. */
export const isComplete = (c: Pick<TrackerCreator, "ticks">, steps: readonly StepDef[]): boolean => steps.length > 0 && steps.every((s) => Boolean(c.ticks[s.id]));

export const progressOf = (c: Pick<TrackerCreator, "ticks">, steps: readonly StepDef[]): number =>
  steps.length ? Math.round((steps.filter((s) => c.ticks[s.id]).length / steps.length) * 100) : 0;
